const getModule = () => import('./onboarding.module')

const lazyLoadModule = [
  '$q',
  '$ocLazyLoad',
  ($q, $ocLazyLoad) => {
    const deferred = $q.defer()
    getModule().then(({ onboardingModule }) => {
      $ocLazyLoad.load({
        name: onboardingModule.name
      })
      deferred.resolve(onboardingModule)
    })
    return deferred.promise
  }
]

/* @ngInject */
function routes ($stateProvider) {
  $stateProvider
    .state('signupWorkflowPlan', {
      url: '/signup/workflow',
      public: true,
      views: {
        '': {
          templateUrl: '/onboarding/pages/signup-workflow-plan/signup-workflow-plan.html?$$REVISION$$',
          controller: 'SignupWorkflowPlanController'
        }
      },
      resolve: {
        lazyLoadModule
      }
    })
    .state('welcome', {
      url: '/welcome',
      public: true,
      views: {
        '': {
          templateUrl: '/onboarding/pages/welcome/welcome.html?$$REVISION$$',
          controller: 'WelcomeController'
        }
      },
      resolve: {
        lazyLoadModule
      }
    })
    .state('onboardingStepBranding', {
      url: '/onboarding/branding',
      views: {
        '': {
          templateUrl: '/onboarding/pages/step-branding/step-branding.html?$$REVISION$$',
          controller: 'StepBrandingController'
        }
      },
      resolve: {
        lazyLoadModule
      }
    })
    .state('onboardingStepBrandingWorkflow', {
      url: '/onboarding/workflow/branding',
      views: {
        '': {
          templateUrl: '/onboarding/pages/step-branding-workflow/step-branding-workflow.html?$$REVISION$$',
          controller: 'StepBrandingWorkflowController'
        }
      },
      resolve: {
        lazyLoadModule
      }
    })
    .state('onboardingStepWaitingEmailConfirmation', {
      url: '/onboarding/waiting-email-confirmation',
      views: {
        '': {
          templateUrl: '/onboarding/pages/step-waiting-email-confirmation/step-waiting-email-confirmation.html?$$REVISION$$',
          controller: 'StepWaitingEmailConfirmationController'
        }
      },
      resolve: {
        lazyLoadModule
      }
    })
    .state('onboardingStepCompany', {
      url: '/onboarding/company',
      views: {
        '': {
          templateUrl: '/onboarding/pages/step-company/step-company.html?$$REVISION$$',
          controller: 'StepCompanyController'
        }
      },
      resolve: {
        lazyLoadModule
      }
    })
    .state('onboardingStepModules', {
      url: '/onboarding/modules',
      views: {
        '': {
          templateUrl: '/onboarding/pages/step-modules/step-modules.html?$$REVISION$$',
          controller: 'StepModulesController'
        }
      },
      resolve: {
        lazyLoadModule
      }
    })
}

export const onboardingRoutes = routes
